// Modules
import React from 'react'
import { useHistory } from 'react-router-dom'

// Application
import ContactNac from 'assets/contact-nac.svg'

// Components
import { TemplateContainerFullWidth, PhonesHelpCenter } from 'components'
import { Content } from '../InnerForm/styles'

export const ConfirmContact: React.FC = () => {
    const history = useHistory()
    const handleNext = () => {
        history.push('/login')
    }
    return (
        <TemplateContainerFullWidth
            buttonText="Voltar para o início"
            goTo={handleNext}
            image={ContactNac}
            imageAlt="Ilustração de telefone"
            title="Confirme seus contatos"
            titleType="medium"
        >
            <Content>
                <p>
                    Você ainda não tem não tem nenhum número de celular ou e-mail cadastrado, e isto é essencial para criar sua conta
                    no Nav Dasa. Para continuar, entre em contato com o time de atendimento e informe um contato válido pelo telefone:
                </p>
                <PhonesHelpCenter />
            </Content>
        </TemplateContainerFullWidth>
    )
}
